<template>

    <b-row class="filter-form p-0">
        <b-col v-for="(d_item, i) in slicedFormFields" class="mt-2" cols="12" :md="d_item.cols" :key="`type ${i} group`"
            :id="d_item.field">
            <b-form-group>
                <label v-if="d_item.type !== 'query'" :for="'input-' + d_item.field" class="mb-3">
                    <strong>{{
                        getLabel(
                            d_item.label
                        )
                    }}<span class="red" v-if="
                            d_item.required
                        ">*</span></strong>
                </label>


                <b-form-select v-if="d_item.type === 'select'" :id="'input-' + d_item.field"
                    v-model="model[d_item.field]" :required="d_item.required" v-custom-validation="d_item.required
                        ? $selectRequired()
                        : ''
                        " :options="getOptions(
                            d_item.field
                        )
                            " :disabled="is_one_off_linked(
                                d_item.field
                            )
                                ">
                    <template #first>
                        <b-form-select-option :value="null" :disabled="d_item.required
                            ">
                            {{
                                `${$translate(
                                    'select'
                                )} ${getLabel(
                                    d_item.label
                                )}`
                            }}
                        </b-form-select-option>
                    </template>
                </b-form-select>

                <b-form-textarea v-else-if="
                    d_item.type ===
                    'textarea'
                " :id="'input-' +
                    d_item.field
                    " v-model="model[d_item.field]
                        " :required="d_item.required
                            " v-custom-validation="d_item.required
                                ? $textRequired()
                                : ''
                                " :placeholder="`${$translate(
                                    'enter'
                                )} ${getLabel(
                                    d_item.label
                                )}`" :rows="3" :max-rows="6">
                </b-form-textarea>

                <b-form-input v-else-if="
                    d_item.field ==
                    'time_of_day'
                " :type="d_item.type" :disabled="is_one_off_linked(
                    d_item.field
                ) ||
                    d_item?.disabled ||
                    false
                    " :id="'input-' +
                        d_item.field
                        " v-model="timeOfDayDisplay
                            " :required="d_item.required
                                " :min="d_item?.min" v-custom-validation="d_item.required
                                    ? $textRequired()
                                    : ''
                                    " :placeholder="`${$translate(
                                        'enter'
                                    )} ${getLabel(
                                        d_item.label
                                    )}`" trim>
                </b-form-input>

                <b-form-checkbox v-else-if="d_item.type === 'checkbox'" :id="'input-' +
                    d_item.field
                    " v-model="model[d_item.field]
                        " :required="d_item.required" :value="true" :unchecked-value="false" style="
                                                            --bs-checkbox-checked-bg: #add8e6;
                                                            --bs-checkbox-checked-border-color: #add8e6;
                                                            width: 24px;
                                                            height: 24px;
                                                            font-size: 18px;
                                                        ">
                </b-form-checkbox>

                <b-form-input v-else :disabled="is_one_off_linked(
                    d_item.field
                ) ||
                    d_item?.disabled ||
                    false
                    " :readonly="!!d_item.readonly" :type="d_item.type" :id="'input-' +
                        d_item.field
                        " v-model="model[d_item.field]
                            " :required="d_item.required
                                " :min="d_item?.min" v-custom-validation="d_item.required
                                    ? $textRequired()
                                    : ''
                                    " :placeholder="`${$translate(
                                        'enter'
                                    )} ${getLabel(
                                        d_item.label
                                    )}`" trim>
                </b-form-input>
            </b-form-group>
        </b-col>
    </b-row>

</template>
<script>
import cmMixins from './cmMixins';

export default {
    name: 'CommunicationsManagement-formBuilder',
    mixins: [cmMixins],
    data() {
        return {

        }
    },
    props: ["value", "slicedFormFields"],

    computed: {
        model: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$set("input", newValue);
            }
        }
    }
}
</script>